module.exports = __webpack_public_path__ + "static/img/top0.6c0a03e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/top0.jpg
// module id = o8yV
// module chunks = 1